export const BASE_URL = "https://api.dilanaslan.com";
